import React, { useState, useEffect, useContext } from "react";

import AppSearchAPIConnector from "@elastic/search-ui-app-search-connector";

import {
    ErrorBoundary,
    Facet,
    SearchProvider,
    SearchBox,
    Results,
    Paging,
    WithSearch
} from "@elastic/react-search-ui";
import { Layout } from "@elastic/react-search-ui-views";
import "@elastic/react-search-ui-views/lib/styles/styles.css";

import {
    buildAutocompleteQueryConfig,
    buildFacetConfigFromConfig,
    buildSearchOptionsFromConfig,
    getConfig,
    getFacetFields
  } from "../../config/config-centros-helper";
  
import CentrosView from "../components/CentrosView";

import { useHistory } from "react-router-dom";
import { Grid } from "@material-ui/core";
import { Logo } from "../../shared/components/Logo";

import '../../styles/busqueda.css';
import NavigationButtons from "../../shared/components/NavigationButtons";
import { UniversityContext } from "../../routes/AppRouter";

import TagManager from 'react-gtm-module';
import { SingleLinksFacetView } from "../../shared/views/SingleLinksFacetView";

export default function Centros({match}) {
    //estados
    const [query, setQuery] = useState("");

    const [checkState, setCheckState] = useState({
      centro:true,
      investigador:false
    })
    
    //setting specific key for university
    const [ universidad ] = useContext(UniversityContext)
    let connector = null;
    let config = null;
    const configFromEngine = getConfig();
    let { hostIdentifier, searchKey, endpointBase, engineName } = configFromEngine;

    //Marca visita de google analytics
    const nombreUniversidad = ""+universidad.id;
    TagManager.dataLayer({
      dataLayer: {
        event: 'visita',
        pagePath: 'centros',
        university: nombreUniversidad,
      },
    });
    
    if( universidad.centros?.engineName ){
      engineName = universidad.centros.engineName;
      connector = new AppSearchAPIConnector({
        searchKey,
        engineName,
        hostIdentifier,
        endpointBase
      });

      config = {
        searchQuery: {
          facets: buildFacetConfigFromConfig(),
          ...buildSearchOptionsFromConfig()
        },
        autocompleteQuery: buildAutocompleteQueryConfig(),
        apiConnector: connector,
        alwaysSearchOnInitialLoad: true
      };
    }
    //end estados

    let url=''+match.url;
    url=url.replace('/centro','');
    
    const { investigador } = checkState;
    let history = useHistory();

    const params = new URLSearchParams(window.location.search)
    let q = params.get('q')
    
    const handleSubmit = (data) => {
      passSearch(data) 
    }

    function passSearch(valor) {
      setQuery(valor);
      console.log('pass');
      if(valor.trim()===''){console.log('vacio');}
    }

    const handleClick = ()=>{
      history.push("/"+match.params?.u+"/");
    }

    useEffect(() => {
      if(q!==null && q!=='null') {
        setQuery(q);
      }
    }, [q]);

    //if the user change the checkbox we redirect it 
    useEffect(() => {
      if(investigador){
        console.log(`${url}investigador/?q=${query}`)
        history.push(`${url}investigador/?q=${query}`)
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [ investigador ])

    return(
      connector && (<SearchProvider config={config}>
          <WithSearch mapContextToProps={({ wasSearched, setSearchTerm  }) => ({ wasSearched, setSearchTerm  })}>
            {({ wasSearched, setSearchTerm }) => {
              return (
                <div className="App">
                  <ErrorBoundary>
                    <Layout
                      header={
                        <div>
                          <Grid
                            container
                            direction="column"
                            justifyContent="center"
                            alignItems="center"
                          >
                            <Grid
                                container
                                item
                                xs={8}
                                md={3}
                            >
                              <Logo />
                            </Grid>
                          </Grid>
                          <div className="searchBar">
                            <div>
                              <button 
                                    className="btn-header"
                                    onClick={ () => { handleClick() }}
                                >
                                  volver
                              </button>

                            </div>
                            <div className="searchBar__search">
                              <SearchBox inputProps={{ placeholder: "Búsqueda de Centros" }} onSubmit={e => {handleSubmit(e);setSearchTerm(e); }}  autocompleteSuggestions={true}/>

                            </div>
                          </div>
                          <Grid
                            container
                            direction="column"
                            justifyContent="center"
                            alignItems="center"
                          >
                            <NavigationButtons state={checkState} setBusqueda={setCheckState}/>
                          </Grid>
                        </div>
                      }
                      sideContent={
                        <div>
                          {getFacetFields().map(field => (
                            <Facet 
                              key={field} 
                              field={field} 
                              label={field} 
                              view={ SingleLinksFacetView }
                            />
                          ))}
                        </div>
                      }
                      bodyContent={
                        <Results
                          titleField={getConfig().titleField}
                          urlField={getConfig().urlField}
                          shouldTrackClickThrough={true}
                          resultView={CentrosView}
                        />
                      }
                      bodyFooter={<Paging />}
                    />
                  </ErrorBoundary>
                </div>
              );
            }}
          </WithSearch>
        </SearchProvider>
        )
    );
}